export default __webpack_public_path__ + "static/media/docs.f59b781d.png";